import React, { useContext, useMemo } from 'react';
import { ReactComponent as PlatesIcon } from 'Icons/ExperimentTab/ExperimentPlate.svg';
import { ReactComponent as DispensedPlateIcon } from 'Icons/ExperimentTab/ExperimentPlateDispensed.svg';
import ProjectSidePanelContext from './projectSidePanelContext';
import EditBarcode from './EditBarcode';
import useRMLite from 'CustomHooks/useRMLite';
import { EPlateState } from 'enums/EPlatestate';
import './ScreenLotsInfoPanel.scss';

const plateClickHandler = (experimentId, selectedPlate) => () => {
  if (experimentId) {
    const link = `screen/${experimentId}/plate/${selectedPlate.id}`;
    window.open(link, link);
  }
};

const ScreenLotsInfoPanel = ({
  screenNodeInfoDTO,
  experimentId,
  plates,
  isEditBarcodeAllowed,
}: any) => {
  const projectSidePanelContext = useContext(ProjectSidePanelContext);
  const rmLite = useRMLite();
  const selectPlate = (plate) => {
    let newSelectedPlateList = [...projectSidePanelContext.selectedPlateList];

    if (newSelectedPlateList.some((plt) => plt.id === plate.id)) {
      newSelectedPlateList = newSelectedPlateList.filter((plt) => plt.id !== plate.id);
    } else {
      newSelectedPlateList.push(plate);
    }
    projectSidePanelContext.setSelectedPlateList(newSelectedPlateList);
  };

  const getPanel = useMemo(() => {
    return (
      <div
        id="screenLotsinfopanel-panel-wrapper"
        className="screenlots-info-panel-wrapper flex w-full h-full flex-col"
      >
        <div
          id="screenLotsinfopanel-panel-label"
          className="nodeInfo nodeLabel flex flex-row w-full p-[1] justify-between"
        >
          <div id="screenLotsinfopanel-panel-row" className="flex flex-row">
            <div id="screenLotsinfopanel-panel-title" className="mr-1">
              Lots Information
            </div>
            (
            <div
              id={`screenLotsinfopanel-panel-detail-${screenNodeInfoDTO.length}`}
              className=" text-[#006af5]"
            >
              {screenNodeInfoDTO.length}
            </div>
            )
          </div>
          <EditBarcode
            plate={projectSidePanelContext?.selectedPlateList[0]}
            setSelectedPlateList={projectSidePanelContext?.setSelectedPlateList}
            onEditPlateBarcode={projectSidePanelContext.onEditPlateBarcode}
            disabled={
              isEditBarcodeAllowed === false ||
              rmLite ||
              projectSidePanelContext?.selectedPlateList.length !== 1 ||
              plates?.find(
                (plate) => plate.id === projectSidePanelContext?.selectedPlateList[0]?.id,
              )?.plateState >= EPlateState.Dispensed
            }
          />
        </div>
        <div
          id="screenlotsinfopanel-panel-list"
          className="flex flex-col overflow-y-auto h-[78%]"
        >
          {screenNodeInfoDTO.map((lots, index) => (
            <div
              id={`screenlotsinfopanel-panel-lot-${index}`}
              key={`lots_${index}`}
              className="screenlots-info-lot"
            >
              <div id={`screenlotsinfopanel-panel-lotname-${index}`}>
                {lots.lotName} {lots.lotComment && ' - ' + lots.lotComment}
              </div>
              {lots.plates.map((plate, index) => (
                <li
                  id={`screenlotsinfopanel-panel-plate-${plate.id}`}
                  className="list-item-container screenlots-info-plate-item node"
                  key={`lots_plate_${index}`}
                >
                  <div
                    id={`screenlotsinfopanel-panel-plate-content-${plate.id}`}
                    className={`list-content flex-xy-center flex-column ${
                      experimentId ? 'cursor-pointer' : ''
                    } ${
                      projectSidePanelContext.selectedPlateList.some(
                        (plt) => plt.id === plate.id,
                      )
                        ? 'selected-explorer-plate'
                        : 'transparent-background'
                    }`}
                    onDoubleClick={plateClickHandler(experimentId, plate)}
                    onClick={() => selectPlate(plate)}
                  >
                    {plates?.find((_plate) => _plate.id === plate.id)?.plateState ===
                    EPlateState.Dispensed ? (
                      <DispensedPlateIcon
                        id={`screenlotsinfopanel-panel-icon-dispensed-${plate.id}`}
                        className="screenlots-info-plate-icon"
                      />
                    ) : (
                      <PlatesIcon
                        id={`screenlotsinfopanel-panel-icon-regular-${plate.id}`}
                        className="screenlots-info-plate-icon"
                      />
                    )}
                    <p
                      id={`screenlotsinfopanel-panel-plate-text-${plate.id}`}
                      className="noSelect-plate nodeText"
                    >
                      {plate.plateNumber}, {plate.id}, {plate.barcode}
                    </p>
                  </div>
                </li>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }, [screenNodeInfoDTO, projectSidePanelContext.selectedPlateList]);

  return <>{getPanel}</>;
};

export default ScreenLotsInfoPanel;
